<div class="standardpanel">
  <div class="titleblock">
    <h3 class="title1level">Dati Generali</h3>
  </div>
  <div class="container_dati_generali" *ngIf="formGroup">
    <div class="row">
      <div class="col-sm-4">
        <p>
          <label for="tipo-prat-dati-gen-lbl">Tipo pratica</label>
          <input id="tipo-prat-dati-gen-lbl" class="form-control" type="text" disabled="" [value]="pratica?.tipoPratica?.descrizione">
        </p>
      </div>
      <div class="col-sm-4">
        <p>
          <label for="stato-dat-gen-prat-lbl">Stato</label>
          <input id="stato-dat-gen-prat-lbl" class="form-control" type="text" disabled="" [value]="pratica.stato ? pratica.stato.label : labelCreatoDaSistema">
        </p>
      </div>
      <div comboModInput class="col-sm-4"
        [labelInput]="'Visibilit&agrave;'"
        [submitPending]="tipiVisibilitaDisabled"
        [noDefaultOption]="true"
        [optionsCombo]="tipiVisibilitaOptions"
        [objectReference]="formGroup.get('tipoVisibilita').value"
        [mandatory]="true"
        (onReturn)="formGroup.get('tipoVisibilita').setValue($event)">
      </div>
    </div>
    <!-- <div class="row">
      <div comboModInput class="col-sm-6" *ngIf="soggettiOptions$ | async as soggettiOptions"
        [labelInput]="'Societ&agrave; / Struttura'" [control]="formGroup.controls['soggetto']" [labelOption]="'nome'"
        [objectReference]="formGroup.get('soggetto').value" [noOrder]="true"
        (onReturn)="formGroup.get('soggetto').setValue($event)" [optionsCombo]="soggettiOptions">
      </div>
    </div> -->
    <div class="row" *ngIf="tipoPratica?.endpoint === tipiPraticaEnum.PENALE">
      <!-- <div comboModInput class="col-sm-4" [labelInput]="'Tipo reato'" *ngIf="tipiReato$ | async as tipiReatoOptions"
           [optionsCombo] ="tipiReatoOptions"
           [objectReference]="formGroup.get('tipoReato').value"
           (onReturn)="formGroup.get('tipoReato').setValue($event)"
           [control]="formGroup.controls['tipoReato']"
           [mandatory]="true"></div> -->

      <div datePickerInput class="col-sm-6" [labelInput]="'Data reato'"
           [formControl]="$any(formGroup).get('dataReato')"></div>

      <div textInput class="col-sm-6" [labelInput]="'Luogo reato'"
           [formControl]="$any(formGroup).get('luogoReato')"></div>
    </div>
    <div class="row" *ngIf="tipoPratica?.endpoint === tipiPraticaEnum.PENALE">
      <div textInput class="col-sm-3"
           [labelInput]="'Numero notizia di reato (RGRN)'"
           [formControl]="$any(formGroup).get('numeroNotiziaDiReato')">
      </div>
      <div checkBoxRadio class="col-sm-3"
           [labelInput]="'Costituzione Parte Civile'" idInput="parteCivile"
           [objectReference]="formGroup.get('costituzioneParteCivile').value"
           [formControl]="$any(formGroup).get('costituzioneParteCivile')"
           (onReturn)="formGroup.get('costituzioneParteCivile').setValue($event)"></div>
      <div checkBoxRadio class="col-sm-3"
           [labelInput]="'Responsabile Civile'" idInput="responsabileCivile"
           [objectReference]="formGroup.get('responsabileCivile').value"
           [formControl]="$any(formGroup).get('responsabileCivile')"
           (onReturn)="formGroup.get('responsabileCivile').setValue($event)">
      </div>
      <div checkBoxRadio class="col-sm-3"
        [labelInput]="'Parte offesa'" idInput="personaOffesa"
        formControlName="personaOffesa"
        [formControl]="$any(formGroup).get('personaOffesa')"
        [objectReference]="request.pratica.personaOffesa"
        (onReturn)="request.pratica.personaOffesa = $event;">
      </div>
    </div>
    <!-- <div class="row"  *ngIf="tipoPratica?.endpoint === tipiPraticaEnum.PENALE"> -->
      <!-- <div datePickerInput class="col-sm-6"
           [labelInput]="'Data iscrizione notizia di reato'"
           [formControl]="$any(formGroup).get('dataIscrizioneNotiziaDiReato')" ></div> -->
    <!-- </div> -->
     <div class="row">
				<div comboModInput class="col-sm-4" [labelInput] = "'Codice'" formControlName = "codice" [labelOption] = "'codice'"
          [formControl]="$any(formGroup).get('codice')"
          [optionsCombo] = "codiceOptions" [objectReference]="selectedCodice" [mandatory]="true" (onReturn)="updateCodice($event)">
        </div>
		</div>
    <div class="row">
      <div textAreaInput class="col-sm-12" [labelInput]="'Oggetto'"
           [formControl]="$any(formGroup).get('oggetto')"></div>
    </div>
    <div class="row">
      <div textAreaInput class="col-sm-12" [labelInput]="'Note'"
           [formControl]="$any(formGroup).get('note')"></div>
    </div>
  </div>

</div>
